// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"giftStore_mainContainer__2RdA9","header":"giftStore_header__7qcCO","scrollableContainer":"giftStore_scrollableContainer__31Jn6"};